export default __webpack_public_path__ + "static/media/ISMO CLASS-4 EXAM PATTERN 2025.3354f680.pdf";